<template>
    <div>
        <navbar></navbar>
        <app-main />
        <root></root>
    </div>
</template>

<script>
import appMain from './components/appmain/index.vue'
import navbar from './components/navbar/index.vue'
import root from './components/root/index.vue'
    export default {
        components: {
            appMain,
            navbar,
            root
        }
    }
</script>

<style lang="scss" scoped>

</style> 